import { ATTACHED_FILE_TYPE } from '@/api/type/commonTypes';
import { FileUploadResult } from '@/libs/r2-service-client';

export const formatAttachedFile = (
  upload: FileUploadResult[]
): ATTACHED_FILE_TYPE[] => {
  return upload.map((uploaded, index) => {
    const ext = uploaded.fileName.includes('.')
      ? uploaded.fileName.split('.').pop() || ''
      : '';
    return {
      id: uploaded.fileId ?? '',
      name: uploaded.fileName,
      size: uploaded.fileSize ?? 0,
      type: ext,
      index,
    };
  });
};
